import React, {Component} from "react";
import PropTypes from "prop-types";

import {Alert, Card, CardBody, Col, Container, Row, Label} from "reactstrap";

import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";

import {Formik, Field, Form, ErrorMessage} from "formik";
import * as Yup from "yup";

import {loginError, loginUser} from "../../store/actions";

import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo-dark.png";

const getCredentials = () => {
  return JSON.parse(localStorage.getItem("rememberAuth"))
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordType: "password",
    }
    this.togPasswordType = this.togPasswordType.bind(this)
  }

  componentDidMount() {
    this.props.loginError("");
  }

  togPasswordType() {
    this.setState(prevState => ({
      passwordType: (this.state.passwordType === "password" && "text") || "password",
    }))
  }

  render() {
    document.title = "Login | FileJet";
    const credentials = getCredentials()
    return (
      <React.Fragment>
        <div className="home-btn d-none d-sm-block">
          <Link to="/" className="text-dark">
            <i className="bx bx-home h2"/>
          </Link>
        </div>
        <div className="account-pages my-5 pt-sm-5">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-primary bg-soft">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4">
                          <h5 className="text-primary">Welcome Back !</h5>
                          <p>Sign in to continue to FileJet.</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid"/>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-0">
                    <div className="auth-logo">
                      <Link to="/" className="auth-logo-dark">
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img src={logo} alt="" className="rounded-circle" height="34"/>
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className="p-2">
                      {this.props.error && this.props.error ? (<Alert color="danger">{this.props.error}</Alert>) : null}
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          username: (credentials && credentials.username) || "",
                          password: (credentials && credentials.password) || "",
                          rememberme: true,
                        }}
                        validationSchema={Yup.object().shape({
                          username: Yup.string().required("Please Enter Your Username"),
                          password: Yup.string().required("Please Enter Valid Password"),
                        })}
                        onSubmit={values => {
                          const credentials = {username: values.username, password: values.password}
                          if (values.rememberme) {
                            localStorage.setItem("rememberAuth", JSON.stringify(credentials))
                          }
                          this.props.loginUser({history: this.props.history, values: credentials});
                        }}
                      >
                        {({errors, status, touched}) => (
                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <Label for="username" className="form-label">
                                Username
                              </Label>
                              <Field id="username" name="username" type="text" className={"form-control" + (errors.username && touched.username ? " is-invalid" : "")}/>
                              <ErrorMessage name="username" component="div" className="invalid-feedback"/>
                            </div>
                            <div className="mb-3">
                              <Label for="password" className="form-label">
                                Password
                              </Label>
                              <div className="input-group auth-pass-inputgroup">
                                <Field id="password" name="password" type={this.state.passwordType} autoComplete="true" className={"form-control" + (errors.password && touched.password ? " is-invalid" : "")}/>
                                <button className="btn btn-light" type="button" id="password-addon" onClick={this.togPasswordType}>
                                  <i className="mdi mdi-eye-outline"></i>
                                </button>
                              </div>
                              <ErrorMessage name="password" component="div" className="invalid-feedback"/>
                            </div>
                            <div className="form-check">
                              <Field name="rememberme" type="checkbox" className="form-check-input" id="rememberme"/>
                              <label className="form-check-label" htmlFor="rememberme">
                                Remember me
                              </label>
                            </div>
                            <div className="mt-3 d-grid">
                              <button className="btn btn-primary btn-block" type="submit">
                                Log In
                              </button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    © {new Date().getFullYear()} FileJet. Crafted with
                    <i className="mdi mdi-heart text-danger"/> by Uniteq Lab
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  loginError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
};

const mapStateToProps = state => {
  const {error} = state.Login;
  return {error};
};

export default withRouter(
  connect(mapStateToProps, {loginUser, loginError})(Login)
);
